import css from 'styled-jsx/css'

export const resultsStyles = css`
.sui-results-container {
  margin: 20px 0 0 0;
  padding: 0;
  list-style: none;
  width: 100%;
}

@media (min-width: 768px){
.sui-results-container {
  margin: 65px 0 0 0;
  }
}
`

export const resultStyles = css`
.result-link{
  display: flex;
  flex-wrap: wrap;
}

.result:not(:first-of-type){
  margin:20px 0;
}

.result :global(p:first-child) {
  margin-bottom: 12px;
}

.result :global(p:nth-child(2)) {
  margin-bottom: 4px;
}

.result-image{
  width: 100%;
  flex-basis: 100%;
  margin-bottom: 20px;
}

.result-content{
  flex-basis: 100%;
}

@media (min-width: 768px){
  .result{
    flex-wrap: nowrap;
  }

  .result-image{
    width: 255px;
    min-width: 255px;
    flex-basis: auto;
    margin-right: 20px; 
    margin-bottom: 0;
  }

  .result-content{
    flex-basis: 70%;
  }
}
`
